import { AnyAction, Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { t } from 'ttag';

import { addAppMessage } from 'uf/appservices/actions';
import { UFState } from 'uf/state';
import { getUser } from 'uf/user/selectors/user';

import {
  INITIALIZE_INTERCOM,
  SHOW_INTERCOM,
  UPDATE_INTERCOM,
} from './ActionTypes';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Window {
    intercomSettings: { app_id?: string } | undefined;
    intercomAppId?: string;
    Intercom: any;
  }
}
export function initializeIntercom(): ThunkAction<AnyAction, any, any, any> {
  return (dispatch: Dispatch, getState) => {
    if (!(__CLIENT__ || __TESTING__)) {
      return;
    }

    const intercomWindow = typeof window !== 'undefined' ? window : undefined;
    const appId =
      intercomWindow?.intercomSettings?.app_id || intercomWindow?.intercomAppId;
    if (!appId) {
      return;
    }

    if (!intercomWindow?.Intercom) {
      dispatch(
        addAppMessage(
          t`It looks like you have an ad-blocker installed in your browser that is blocking our support tools. Please add UrbanFootprint as an approved site to receive online support.`,
        ),
      );
      return;
    }
    const user = getUser(getState());
    const intercomSettings = {
      app_id: appId,
      name: user.first_name || user.email,
      email: user.email,
      intercom_user_jwt: user.intercom_user_jwt,
      alignment: 'left',
      vertical_padding: 35,
      horizontal_padding: 10,
    };
    intercomWindow?.Intercom('boot', intercomSettings);
    return dispatch({
      type: INITIALIZE_INTERCOM,
    });
  };
}

export function showIntercom(message?: string) {
  return {
    type: SHOW_INTERCOM,
    message,
  };
}

export function updateIntercom(): ThunkAction<void, UFState, any, any> {
  return dispatch => {
    window.Intercom.update();
    dispatch({ type: UPDATE_INTERCOM });
  };
}
